export const CALLBACK_URL = process.env.REACT_APP_WOO_COMMERCE_CALLBACK as string;
export const SCOPE = "read_write";
